module.exports = __webpack_public_path__ + "img/plus.90dfe1be.svg";